import { IProductOffer } from '../../types';
import { ProductInterface } from '../../../../services/exports/Interfaces';
import { useTranslation } from 'react-i18next';

const usePercentageOffByProducts: IProductOffer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });

  return (offer) => {
    const isEligible = (item: ProductInterface) => item && offer.details.products.includes(item.id);
    const badge =
      offer &&
      t(offer.kind, {
        percentageAmount: offer.details.percentage_amount,
      });

    return { isEligible, badge };
  };
};

export default usePercentageOffByProducts;
